import PopUp, { IPopUpRef } from "@/modules/ui-elements/PopUp"
import React, { useImperativeHandle, useRef, useState } from "react";
import styles from './styles.module.css';
import Image from 'next/image';
import UploadWidget from "./UploadWidget";
import HomepageUpload from "src/modules/file-upload/homepageUpload";
import { list, getToolTypeFromTitle } from "@/utils/toolsConstants";
import { aiTaskDisableAtom } from "@/modules/batchEditor/atoms";
import { useSetAtom } from "jotai";

type onUploadSuccessType = (asset)=>Promise<any>;
type onUploadFailureType = (error)=>Promise<any>;
type onSingleImageBulkUploadType = (job)=>Promise<any>;

export interface IUploadPopUpOpenOptions {
    title: string,
    onUploadSuccess?: onUploadFailureType
    onUploadFailure?: onUploadSuccessType
    singleImageBulkUpload?:boolean
    onSingleImageBulkUpload?:onSingleImageBulkUploadType
    widgetImage?:string
    initiatedSource?:boolean
    marketplaceId?: string
    batchEditorJobPopUp?: boolean
    aiTaskDisable?: boolean
    onGoogleDriveUpload?: () => Promise<void>
    batchAI?:string
}

export interface IUploadPopUpRef {
    open: (options:IUploadPopUpOpenOptions)=>void,
    close: ()=>void
}

export interface IUploadPopUpProps {

}

const UploadPopUp = React.forwardRef<IUploadPopUpRef,IUploadPopUpProps>(function UploadPopUp(props,ref) {

    const popUpRef = useRef<IPopUpRef>(null);
    const [title,setTitle] = React.useState<string>("");
    const [popupImage, setPopupImage] = useState<string>("");

    const [onUploadSuccess, setOnUploadSuccess] = useState<onUploadSuccessType>(()=>async()=>{});
    const [onUploadFailure, setOnUploadFailure] = useState<onUploadFailureType>(()=>async()=>{});
    const [onSingleImageBulkUpload, setOnSingleImageBulkUpload] = useState<onSingleImageBulkUploadType>(()=>async()=>{});
    const [onGoogleDrive, setOnGoogleDrive] = useState<() => Promise<void>>(() => async () => null);
    
    const [singleImageBulkUpload, setSingleImageBulkUpload] = useState<boolean>(false);
    const [initiatedSource, setinitiatedSource] = React.useState<any>('');
    const [marketPlaceIntiatedSource, setMarketPlaceIntiatedSource]= React.useState<any>('');
    const [batchEditorJobPopUp, setBatchEditorJobPopUp]= React.useState<any>(false);
    const [isBulkAIType,setBulkAIType] = useState<boolean>(false);
    const [aiTaskDisable, setAiTaskDisable]= React.useState<any>(false);
    const setAiTaskDisableAtom = useSetAtom(aiTaskDisableAtom);

    const onCloseButtonClick = ()=>{
        setBatchEditorJobPopUp(false)
        setMarketPlaceIntiatedSource('')
        setinitiatedSource('')
        setAiTaskDisable(false)
        setAiTaskDisableAtom(false);
        setBulkAIType(false);
    }

    useImperativeHandle(ref,()=>({
        open: (options)=>{
            setTitle(options.title);
            setPopupImage(options.widgetImage);
            options.singleImageBulkUpload && setSingleImageBulkUpload(true);
            if(options.marketplaceId)
            {
                setMarketPlaceIntiatedSource(options.marketplaceId)
                setinitiatedSource('marketplace')
                setBatchEditorJobPopUp(options?.batchEditorJobPopUp)
            }
            else{
                if(options?.batchAI){
                    setBatchEditorJobPopUp(true);
                    setBulkAIType(true);
                }else{
                setinitiatedSource(getToolTypeFromTitle(options.title))
                setBatchEditorJobPopUp(options?.batchEditorJobPopUp)
                }
            }
            if (options.onGoogleDriveUpload) setOnGoogleDrive(() => options.onGoogleDriveUpload);
            if(options.singleImageBulkUpload) setOnSingleImageBulkUpload(()=>options.onSingleImageBulkUpload);
            if(options.onUploadSuccess) setOnUploadSuccess(()=>options.onUploadSuccess);

            else setOnUploadSuccess(()=>async()=>{});
            if(options.onUploadFailure) setOnUploadFailure(()=>options.onUploadFailure)
            else setOnUploadFailure(()=>async()=>{});
            if (options.aiTaskDisable) {
                setAiTaskDisable(true);
            }
            popUpRef.current.open();
        },
        close: ()=>{
            popUpRef.current.close();
        }
    }));

    const style = {display:"flex", flex:1};

    return <PopUp 
      ref={popUpRef}
      onCloseButtonClick={onCloseButtonClick}
      width={batchEditorJobPopUp ? 650 : 1088}
      disableBackdropClick={true}
      showCloseButton={true}
      styleBody={{padding:`${batchEditorJobPopUp && "0px"}`, userSelect: 'none'}}
    >
      <div className={styles.header}>
        <div><b>{title}</b></div>
        {batchEditorJobPopUp && <div>Upload</div>}
      </div>
      <div className={styles.row}>
          {batchEditorJobPopUp ? 
            <HomepageUpload
              isBulkAIType={isBulkAIType} 
              onCloseButtonClick={onCloseButtonClick}
              marketPlaceIntiatedSource={marketPlaceIntiatedSource}
              initiatedSource={initiatedSource}
              onGoogleDriveUpload={onGoogleDrive}
              onUploadSuccess={onUploadSuccess}
              onUploadFailure={onUploadFailure}
              aiTaskDisable={aiTaskDisable}
            /> 
            : <> 
              <div>
                  <Image
                    src={popupImage || "/icons/UploadPopUpBanner.png"}
                    height={350} width={510}
                    alt={"Banner Image"} 
                    quality={100} 
                  />
              </div>
              <div style={style}>
                <UploadWidget
                  onUploadSuccess={onUploadSuccess}
                  onUploadFailure={onUploadFailure}
                  singleImageBulkUpload={singleImageBulkUpload}
                  onSingleImageBulkUpload={onSingleImageBulkUpload}
                />
              </div>
            </>
          }
      </div>
    </PopUp>
  });

export default UploadPopUp;